import React, { Component } from "react";
import {
  Segment,
  Grid,
  Header,
  Container,
  Responsive,
  Icon,
  Button,
  Image
} from "semantic-ui-react";
import { onInstagramClick, onFacebookClick } from "./../js";
import colors from "../js/colors";
import Slider from "react-slick";

import "react-multi-carousel/lib/styles.css";

const importAll = param => {
  return param.keys().map(param);
};

const redes = importAll(
  require.context("./../static/redes", false, /\.(png|jpe?g|svg)/)
);
const varais = importAll(
  require.context("./../static/varais", false, /\.(png|jpe?g|svg)/)
);

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div onClick={onClick}>
      <button className={"slick-arrow slick-next"}>
        <Icon name="angle right" size="big" style={{ color: "black" }} />
      </button>
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div onClick={onClick}>
      <button className={"slick-arrow slick-prev"}>
        <Icon name="angle left" size="big" style={{ color: "black" }} />
      </button>
    </div>
  );
}

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  className: "slick-produtos-custom",
  centerMode: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
};

const ResponsiveCarousel = ({ mobile }) => {
  const images = [...redes, ...varais];
  return (
    <Slider {...settings}>
      {images.map((element, index) => (
        <div key={`slider-card-${index}`} className="one-edge-shadow">
          
          <Image
            
            src={element}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      ))}
    </Slider>
  );
};

export default class ImagensComponent extends Component {
  render() {
    return (
      <Segment
        inverted
        vertical
        style={{
          paddingTop: "100px",
          paddingBottom: "50px",
          backgroundColor: colors.dark
        }}
      >
        <Container style={{ paddingRight: "15px", paddingLeft: "15px" }}>
          <Grid celled="internally" columns="equal" stackable>
            <Grid.Row>
              <Grid.Column>
                <Header as="h3" style={{ color: "white" }}>
                  Trabalhos realizados:
                </Header>
                <Header
                  as="h4"
                  style={{ color: "white", marginTop: 50, marginBottom: 50 }}
                >
                  Veja também pelo nosso{" "}
                  <Button
                    size="tiny"
                    color="instagram"
                    onClick={() => onInstagramClick()}
                    style={{ marginLeft: "10px", marginTop: "10px" }}
                  >
                    <Icon name="instagram" /> Instagram
                  </Button>
                  {" e "}
                  <Button
                    size="tiny"
                    color="facebook"
                    onClick={() => onFacebookClick()}
                    style={{ marginLeft: "5px", marginTop: "10px" }}
                  >
                    <Icon name="facebook" /> Facebook
                  </Button>
                </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row textAlign="center">
              <Grid.Column>
                <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
                  <ResponsiveCarousel mobile={true} />
                </Responsive>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                  <ResponsiveCarousel mobile={false} />
                </Responsive>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
}
